import React, {Component} from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import './dateSelection.css'

class DateSelection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: props.defaultStartDate ? moment(props.defaultStartDate) : 
        /*props.timezone ? moment().startOf('month').tz(props.timezone) : moment().startOf('month')*/null ,
      endDate: props.defaultEndDate ? moment(props.defaultEndDate) : null,
      activeMonth: true,
      activeMonthEnd: true,
      compareStartDate: props.defaultStartDate ? moment(props.defaultStartDate) : 
      props.timezone ? moment().startOf('month').tz(props.timezone) : moment().startOf('month') ,
      compareEndDate: props.defaultEndDate ? moment(props.defaultEndDate) : props.timezone ? 
        moment().endOf('month').tz(props.timezone) :  moment().endOf("month")
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.defaultStartDate !== this.props.defaultStartDate) {
      this.setState({
        startDate: nextProps.defaultStartDate ? moment(nextProps.defaultStartDate) : null
      })
    }
    if (nextProps.defaultEndDate !== this.props.defaultEndDate) {
      this.setState({
        endDate: nextProps.defaultEndDate ? moment(nextProps.defaultEndDate) : null
      })
    }
  }
  handleStartDateChange(startDate) {
    this.props.startDateChange(startDate ? startDate.format('YYYY-MM-DD') : null);

    if (startDate) {
      this.handleChange({ startDate });
    } else {
      this.setState({startDate: null})
    }
  }
  handleEndDateChange(endDate) {
    this.props.endDateChange(endDate ? endDate.format('YYYY-MM-DD') : null);
    if (endDate) {
      this.handleChange({ endDate });
    } else {
      this.setState({endDate: null})
    }
  }
  handleChange({ startDate, endDate }) {
    startDate = startDate || this.state.startDate
    endDate = endDate || this.state.endDate;

    if (startDate && startDate.isAfter(endDate)) {
      if (!endDate)
        endDate = startDate
      this.setState({
        compareEndDate: startDate
      })
    }
    this.setState({
      startDate,
      endDate
    })
  }
  handleClickDateWrapper () {
    let eles = document.querySelectorAll('.react-datepicker__day-name');
    // change month name
    for (const v of eles) {
      v.innerText = v.innerText.substring(0, 1)
    }
  }
  handleOnMonthChange (date) {
    this.setState({
      compareStartDate: date
    })
  }
  handleOnEndMonthChange (date) {
    this.setState({
      compareEndDate: date
    })
  }

  /**
   * this callback of apply button
   */
  handleApplyBeClick() {
    this.props.handleApplyBeClick()
  }

  clickOutsiteDatePicker(type){
    switch(type) {
      case "end":
        this.refs.endDatePicker.cancelFocusInput();
        this.refs.endDatePicker.setOpen(false);
        break;
      case "start":
      default:
        this.refs.startDatePicker.cancelFocusInput();
        this.refs.startDatePicker.setOpen(false);
        break;      
    }
  }
  render () {
    return (
      <div className="date-selection">
        <h2>Campaign Reporting Filter</h2>
        <p>
          Filter campaigns by date.
        </p>
        <div className="content clearfix">
          <span>From:</span>
          <div className="start-date clearfix">
            <div className="icon-wrapper">
              <i className="far fa-calendar-alt" />
            </div>
            <div className="date-wrapper" onClick={() => this.handleClickDateWrapper()}>
              <DatePicker
                ref="startDatePicker" 
                key="date-picker-start-date"
                dateFormat="MM-DD-YYYY"
                calendarClassName="calendar-left"
                className="date-con"
                selected={this.state.startDate}
                isClearable={true}
                startDate={this.state.startDate}
                filterDate={(date) => date.format('M') === this.state.compareStartDate.format('M')}
                onMonthChange={(date) => this.handleOnMonthChange(date)}
                onChange={(date) => this.handleStartDateChange(date)}
                onClickOutside={()=> this.clickOutsiteDatePicker("start")}
              />
            </div>
          </div>
          <strong className="line"></strong>
          <span>To:</span>
          <div className="end-date">
            <div className="icon-wrapper">
              <i className="far fa-calendar-alt" />
            </div>
            <div className="date-wrapper" onClick={() => this.handleClickDateWrapper()}>
              <DatePicker
                ref="endDatePicker" 
                key="date-picker-end-date"
                dateFormat="MM-DD-YYYY"
                calendarClassName="calendar-left"
                className="date-con"
                endDate={this.state.endDate}
                isClearable={true}
                selected={this.state.endDate}
                filterDate={(date) => date.format('M') === this.state.compareEndDate.format('M')}
                onMonthChange={(date) => this.handleOnEndMonthChange(date)}
                onChange={(date) => this.handleEndDateChange(date)}
                onClickOutside={()=> this.clickOutsiteDatePicker("end")}
              />
            </div>
          </div>
          <button className="apply" onClick={() => this.handleApplyBeClick()}>Apply</button>
        </div>
      </div>
    )
  }
}

export default DateSelection;


// WEBPACK FOOTER //
// ./src/components/Campaigns/DateSelection/Date.jsx